var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function layoutSankey(nodes, links, width, height, nodeWidth) {
    var e_1, _a;
    var _b, _c;
    if (nodeWidth === void 0) { nodeWidth = 12; }
    var cols = 3;
    var colW = width / cols;
    var inflow = new Map();
    var outflow = new Map();
    try {
        for (var links_1 = __values(links), links_1_1 = links_1.next(); !links_1_1.done; links_1_1 = links_1.next()) {
            var l = links_1_1.value;
            inflow.set(l.target, ((_b = inflow.get(l.target)) !== null && _b !== void 0 ? _b : 0) + l.value);
            outflow.set(l.source, ((_c = outflow.get(l.source)) !== null && _c !== void 0 ? _c : 0) + l.value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (links_1_1 && !links_1_1.done && (_a = links_1.return)) _a.call(links_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var total = links.reduce(function (a, l) { return a + l.value; }, 0) || 1;
    var layoutNodes = nodes.map(function (n, i) {
        var _a, _b, _c;
        var col = i % cols;
        var flow = Math.max((_a = inflow.get(n.id)) !== null && _a !== void 0 ? _a : 0, (_b = outflow.get(n.id)) !== null && _b !== void 0 ? _b : 0, 1);
        var h = (flow / total) * height * 0.8;
        return {
            id: n.id,
            label: (_c = n.label) !== null && _c !== void 0 ? _c : n.id,
            x: col * colW + colW / 2 - nodeWidth / 2,
            y: 20 + (i % 4) * (h + 10),
            width: nodeWidth,
            height: Math.max(20, h),
        };
    });
    var nodeMap = new Map(layoutNodes.map(function (n) { return [n.id, n]; }));
    var layoutLinks = links
        .map(function (l) {
        var source = nodeMap.get(l.source);
        var target = nodeMap.get(l.target);
        if (!source || !target)
            return null;
        var sx = source.x + source.width;
        var sy = source.y + source.height / 2;
        var tx = target.x;
        var ty = target.y + target.height / 2;
        var mx = (sx + tx) / 2;
        var path = "M ".concat(sx, " ").concat(sy, " C ").concat(mx, " ").concat(sy, " ").concat(mx, " ").concat(ty, " ").concat(tx, " ").concat(ty);
        return { source: source, target: target, value: l.value, path: path };
    })
        .filter(function (l) { return l != null; });
    return { nodes: layoutNodes, links: layoutLinks };
}
export function chordPath(cx, cy, r, startAngle, endAngle) {
    var x1 = cx + r * Math.cos(startAngle);
    var y1 = cy + r * Math.sin(startAngle);
    var x2 = cx + r * Math.cos(endAngle);
    var y2 = cy + r * Math.sin(endAngle);
    var large = endAngle - startAngle > Math.PI ? 1 : 0;
    return "M ".concat(x1, " ").concat(y1, " A ").concat(r, " ").concat(r, " 0 ").concat(large, " 1 ").concat(x2, " ").concat(y2);
}
/** Layout a chord diagram from an adjacency matrix. */
export function layoutChord(matrix, size, padAngle) {
    var _a;
    if (padAngle === void 0) { padAngle = 0.04; }
    var n = matrix.length;
    var cx = size / 2;
    var cy = size / 2;
    var outerR = size / 2 - 16;
    var innerR = outerR - 18;
    var totals = matrix.map(function (row) { return row.reduce(function (a, v) { return a + v; }, 0); });
    var grand = totals.reduce(function (a, v) { return a + v; }, 0) || 1;
    var tau = Math.PI * 2;
    var gap = padAngle;
    var angle = -Math.PI / 2;
    var segments = [];
    for (var i = 0; i < n; i++) {
        var sweep = (totals[i] / grand) * tau;
        var start = angle + gap / 2;
        var end = angle + sweep - gap / 2;
        segments.push({ index: i, startAngle: start, endAngle: end, value: totals[i] });
        angle += sweep;
    }
    var ribbons = [];
    for (var i = 0; i < n; i++) {
        var row = matrix[i];
        var outTotal = row.reduce(function (a, v) { return a + v; }, 0) || 1;
        var outAcc = 0;
        var _loop_1 = function (j) {
            var v = row[j];
            if (!v)
                return "continue";
            var segI = segments[i];
            var segJ = segments[j];
            var srcSpan = segI.endAngle - segI.startAngle;
            var tgtSpan = segJ.endAngle - segJ.startAngle;
            var sa1 = segI.startAngle + (outAcc / outTotal) * srcSpan;
            var ea1 = segI.startAngle + ((outAcc + v) / outTotal) * srcSpan;
            outAcc += v;
            var inTotal = matrix.reduce(function (a, r) { var _a; return a + ((_a = r[j]) !== null && _a !== void 0 ? _a : 0); }, 0) || 1;
            var inBefore = 0;
            for (var k = 0; k < i; k++)
                inBefore += (_a = matrix[k][j]) !== null && _a !== void 0 ? _a : 0;
            var sa2 = segJ.startAngle + (inBefore / inTotal) * tgtSpan;
            var ea2 = segJ.startAngle + ((inBefore + v) / inTotal) * tgtSpan;
            ribbons.push({
                source: i,
                target: j,
                value: v,
                path: chordRibbonPath(cx, cy, outerR, innerR, sa1, ea1, sa2, ea2),
            });
        };
        for (var j = 0; j < n; j++) {
            _loop_1(j);
        }
    }
    return { cx: cx, cy: cy, outerR: outerR, innerR: innerR, segments: segments, ribbons: ribbons };
}
/** Filled ribbon between two arc spans on a chord diagram. */
export function chordRibbonPath(cx, cy, outerR, _innerR, sa1, ea1, sa2, ea2) {
    var p = function (r, a) { return [cx + r * Math.cos(a), cy + r * Math.sin(a)]; };
    var _a = __read(p(outerR, sa1), 2), x00 = _a[0], y00 = _a[1];
    var _b = __read(p(outerR, ea1), 2), x01 = _b[0], y01 = _b[1];
    var _c = __read(p(outerR, sa2), 2), x10 = _c[0], y10 = _c[1];
    var _d = __read(p(outerR, ea2), 2), x11 = _d[0], y11 = _d[1];
    var large1 = Math.abs(ea1 - sa1) > Math.PI ? 1 : 0;
    var large2 = Math.abs(ea2 - sa2) > Math.PI ? 1 : 0;
    return "M ".concat(x00, " ").concat(y00, " A ").concat(outerR, " ").concat(outerR, " 0 ").concat(large1, " 1 ").concat(x01, " ").concat(y01, " Q ").concat(cx, " ").concat(cy, " ").concat(x10, " ").concat(y10, " A ").concat(outerR, " ").concat(outerR, " 0 ").concat(large2, " 1 ").concat(x11, " ").concat(y11, " Q ").concat(cx, " ").concat(cy, " ").concat(x00, " ").concat(y00, " Z");
}
